/*
Author : Mateo Mirindi
Company : Numerik
Fichier : src/components/listings/variations-types/Create.js
Created On : 17 May 2022 12:23:48
*/

import React, { useState } from "react"
import { Form, Modal } from "react-bootstrap"
import { STORE_LISTINGS_VARIATIONS_TYPE } from "../../../routes/api"
import { useMakeRequest } from "../../../services/httpClient"
import { notify } from "../../../services/Notification"
import { setValidationErrors } from "../../../services/Validation"
import { Button, FormGroup } from "../../utilities"

const Create = ({ show, onHide }) => {
  const [type, setType] = useState("")
  const [errors, setErrors] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const { makeRequest } = useMakeRequest()

  function onSubmit(e) {
    e.preventDefault()
    makeRequest({
      method: "put",
      route: STORE_LISTINGS_VARIATIONS_TYPE,
      data: { type: type },
      setLoader: setIsLoading,
      onSuccess: onSuccess,
      onError: onError,
    })
  }

  function onSuccess(response) {
    if (response.status === 201) {
      notify({ message: response.data.message })
      onHide()
    }
  }

  function onError(error) {
    setValidationErrors(setErrors, error)
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Form method="post" onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Ajouter un type de variation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormGroup
            label="Type de variation"
            value={type}
            onChange={setType}
            error={errors.type}
            required={true}
            disabled={isLoading}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            role="button"
            onClick={onHide}
            disabled={isLoading}
          >
            Annuler
          </Button>
          <Button
            variant="primary"
            type="submit"
            disabled={isLoading}
            isLoading={isLoading}
          >
            Ajouter
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  )
}

export default Create
